<template>
  <!-- Table Container Card -->
  <div>
    <div class="col-6 d-flex align-items-center justify-content-lg-start">
      <Button
        v-if="(showBackButton && actionType === 'save') || 'add'"
        label="List page"
        size="md"
        icon="ArrowLeftIcon"
        show-icon
        class="mb-1"
        @click="backNavigationAction"
      />
    </div>
    <form-wizard
      ref="groupCustomerForm"
      :title="null"
      :subtitle="null"
      layout="vertical"
      finish-button-text="Save"
      back-button-text="Previous"
      class="wizard-vertical mb-3"
    >
      <!-- Group/Organisation tab -->
      <tab-content
        title="Corporate/Group"
        :before-change="validateGroup"
      >
        <validation-observer ref="groupRules">
          <b-form>
            <b-row v-if="getUserPermission('VALIDATE_TIN')">
              <b-col
                md="4"
              >
                <InputField
                  id="tin"
                  v-model="groupCustomerInfo.tin"
                  label="TIN"
                  placeholder="Enter TIN"
                  type="text"
                  :readonly="isTIN"
                />
              </b-col>
              <b-col
                v-if="getUserPermission('VALIDATE_TIN')"
                md="4"
              >
                <Button
                  label="Validate"
                  :loading="isLoading"
                  size="md"
                  class="mt-2 btn-text-right"
                  @click="tinValidateAction"
                />
              </b-col>
            </b-row>
            <b-row class="match-height">
              <b-col
                v-if="!getUserPermission('VALIDATE_TIN')"
                md="4"
              >
                <InputField
                  id="tin"
                  v-model="groupCustomerInfo.tin"
                  label="TIN"
                  placeholder="Enter TIN"
                  type="text"
                  :readonly="isTIN"
                />
              </b-col>
              <b-col md="4">
                <SelectField
                  id="customer-type"
                  v-model="groupCustomerInfo.customerType"
                  label="Customer Type"
                  :options="customerTypeOptions"
                  error-name="Customer Type"
                  rules="required"
                  item="label"
                  :reduce="(option) => option.value"
                  placeholder="Select"
                />
              </b-col>

              <!-- Group/Organisation Name -->
              <b-col md="4">
                <InputField
                  id="group-name"
                  v-model="groupCustomerInfo.name"
                  label="Corporate/Group Name"
                  placeholder="Enter corporate/group name"
                  type="text"
                  error-name="Corporate/Group Name"
                  rules="required"
                  for="group-name"
                  onpaste="return false;"
                  :is-allow-special-characters="false"
                />
              </b-col>
              <!-- Group/Organisation Name -->

              <!-- Description -->
              <b-col md="4">
                <InputField
                  id="description"
                  v-model="groupCustomerInfo.description"
                  label="Description"
                  placeholder="Enter description"
                  type="text"
                  error-name="Description"
                  rules="required"
                  for="description"
                />
              </b-col>
              <!-- Description -->
              <!-- Business Phone Number -->
              <b-col md="4">
                <ValidationObserver>
                  <InputField
                    id="business-number"
                    v-model="groupCustomerInfo.businessPhoneNumber"
                    label="Business Phone Number"
                    placeholder="Enter business phone number"
                    type="number"
                    error-name="Business Phone Number"
                    rules="required|integer|min:7|max:15"
                    for="business-number"
                    :on-input="setBussinessPhoneNumber"
                  />
                </ValidationObserver>
              </b-col>
              <!-- Business Phone Number -->
              <!-- Secondary Phone Numbers -->
              <b-col md="8">
                <TextAreaField
                  id="sec-phone-number"
                  v-model="groupCustomerInfo.notificationPhoneNumber"
                  label="Notification Phone Number"
                  placeholder="For multiple Phone Numbers, separate by comma (,)"
                  type="text"
                  for="sec-phone-number"
                  rows="2"
                  error-name="Business Phone Number"
                  rules="required"
                  show-icon
                  :on-click="onViewPhoneInfo"
                />
              </b-col>
              <!-- Secondary Phone Number -->

              <!-- Email -->
              <b-col md="4">
                <b-form-group>
                  <InputField
                    id="email"
                    v-model="groupCustomerInfo.email"
                    label="Email"
                    placeholder="Enter email"
                    type="email"
                    error-name="Email"
                    rules="email"
                    :on-input="setBussinessEmailAddress"
                  />
                </b-form-group>
              </b-col>
              <!--  Email -->

              <!-- Secondary Email -->
              <b-col md="8">
                <TextAreaField
                  id="sec-email"
                  v-model="groupCustomerInfo.notificationEmail"
                  label="Notification Email"
                  placeholder="For multiple Emails, separate by comma (,)"
                  type="text"
                  rules="email"
                  error-name="Email"
                  rows="2"
                  show-icon
                  :on-click="onViewEmailInfo"
                />
              </b-col>
              <!-- Secondary Email -->

              <!--  Nature of Business -->
              <b-col md="4">
                <b-form-group>
                  <InputField
                    id="nature-of-business"
                    v-model="groupCustomerInfo.natureOfBusiness"
                    label=" Nature of Business"
                    placeholder="Enter nature of business"
                    type="text"
                    error-name="Nature of Business"
                    rules="required"
                    for="nature-of-business"
                  />
                </b-form-group>
              </b-col>
              <!--  Nature of Business -->

              <!-- Industrial Sector -->
              <b-col md="4">
                <SelectField
                  id="industrial-sector"
                  v-model="groupCustomerInfo.industrialSector"
                  label="Industrial Sector"
                  :options="industrialSectorsOptions"
                  error-name="Industrial Sector"
                  rules="required"
                  item="label"
                  :reduce="(option) => option.value"
                  placeholder="Select"
                />
              </b-col>
              <!-- Industrial Sector -->
              <!-- Registration Date -->
              <b-col md="4">
                <DatePickerField
                  id="registration-date"
                  v-model="groupCustomerInfo.registrationDate"
                  label="Registration Date"
                  :config="datePickerConfig"
                />
              </b-col>
              <!--  Registration Date -->

              <!--  Incorporation Date -->
              <b-col md="4">
                <DatePickerField
                  id="incorporation-date"
                  v-model="groupCustomerInfo.incorporationDate"
                  label="Incorporation Date"
                  :config="datePickerConfig"
                  placeholder="Incorporation Date"
                />
              </b-col>
              <!--   Incorporation Date -->

              <!-- Registration Number -->
              <b-col md="4">
                <InputField
                  id="registration-number"
                  v-model="groupCustomerInfo.registrationNumber"
                  label="Registration Number"
                  placeholder="Enter registration number"
                  type="text"
                />
              </b-col>
              <!--  Registration Number -->
              <!-- </b-row>

            <b-row class="match-height"> -->
              <!-- Email -->

              <!-- Contact Person's Name -->
              <b-col md="4">
                <b-form-group>
                  <InputField
                    id="contact-person"
                    v-model="groupCustomerInfo.contactPersonName"
                    label="Contact Person's Name"
                    placeholder="Enter contact person's name"
                    type="text"
                    error-name="Contact Person's Name"
                    rules="required"
                  />
                </b-form-group>
              </b-col>
              <!-- Contact Person's Name -->

              <!-- Contact Person's Number -->
              <b-col md="4">
                <b-form-group>
                  <InputField
                    id="contact-number"
                    v-model="groupCustomerInfo.contactPersonPhoneNumber"
                    label="Contact Person's Number"
                    placeholder="Enter contact person's number"
                    type="number"
                    error-name="Contact Person's Number"
                    rules="required|integer|min:7|max:15"
                  />
                </b-form-group>
              </b-col>
              <!-- Contact Person's Number -->
              <!--  Country of Operation -->
              <b-col md="4">
                <SelectField
                  id="country-of-operation"
                  v-model="groupCustomerInfo.countryOfOperation"
                  label="Country of Operation"
                  :options="countryOptions"
                  :reduce="(option) => option"
                  item="label"
                  placeholder="Select"
                  error-name="Country of Operation"
                  rules="required"
                />
              </b-col>
              <!--  Country of Operation-->
              <!-- State of Operation-->
              <b-col md="4">
                <SelectField
                  id="state-of-operation"
                  v-model="groupCustomerInfo.stateOfOperation"
                  label="State of Operation"
                  :options="stateOptions"
                  :reduce="(option) => option"
                  item="label"
                  placeholder="Select"
                  :set-selected="getLGAByState"
                  error-name="State of Operation"
                  rules="required"
                />
              </b-col>
              <!--  State -->

              <!-- LGA -->
              <b-col md="4">
                <SelectField
                  id="lga"
                  v-model="groupCustomerInfo.lga"
                  label="LGA"
                  :options="lgaOptions"
                  :reduce="(option) => option"
                  item="label"
                  placeholder="Select"
                  error-name="LGA"
                  rules="required"
                />
              </b-col>
              <!--  LGA -->

              <!--  Old customer ID -->
              <b-col md="4">
                <InputField
                  id="reference-number"
                  v-model="groupCustomerInfo.oldCustomerID"
                  label="Old customer ID"
                  placeholder="Enter old customer ID"
                  type="text"
                  show-icon
                  :on-click="onViewInfo"
                />
              </b-col>
              <!--  Old customer ID -->
              <!-- Alias -->
              <b-col md="4">
                <InputField
                  id="alias"
                  v-model="groupCustomerInfo.alias"
                  label="Alias"
                  placeholder="Enter alias"
                  type="text"
                />
              </b-col>
              <!-- Alias -->
            </b-row>

            <!--  Official Address -->
            <b-row class="match-height">
              <b-col md="12">
                <TextAreaField
                  id="official-address"
                  v-model="groupCustomerInfo.address"
                  label="Official Address"
                  placeholder="Enter address"
                  for="official-address"
                  rows="5"
                />
              </b-col>
            </b-row>
            <!-- Official Address -->

            <!-- <div class="text-center">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              size="lg"
              @click.prevent="creategroupCustomerInfoAction"
            >
              Save
            </b-button>
          </div> -->
          </b-form>
        </validation-observer>
      </tab-content>

      <!-- Customers/Signatories tab -->
      <tab-content title="Signatories">
        <Alert
          :show="showFormErrorAlert"
          message="Customer's account name or account number is required"
        />
        <b-row>
          <b-col md="4">
            <InputField
              id="customer-id"
              v-model="searchParams.customerID"
              label="Customer ID"
              placeholder="Enter customer ID"
              type="number"
            />
          </b-col>
          <b-col md="4">
            <InputField
              id="customer-name"
              v-model="searchParams.name"
              label="Customer Name"
              placeholder="Enter customer name"
              type="text"
            />
          </b-col>
          <b-col md="4">
            <Button
              label="Search"
              size="md"
              class="mt-2"
              @click="handleSearch"
            />
          </b-col>
        </b-row>
        <div v-if="signatoryList !== null">
          <b-table
            ref="signatoryRef"
            :items="signatoryList"
            responsive
            :fields="tableHeaders"
            primary-key="id"
            show-empty
            selectable
            empty-text="No result found"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            class="position-relative mt-3"
          >
            <template #cell(SN)="data">
              {{ data.index + 1 }}
            </template>

            <template #cell(lastName)="data">
              {{
                `${data.item.lastName} ${data.item.firstName} ${data.item.otherNames} `
              }}
            </template>

            <template #cell(actions)="data">
              <Button
                label="Remove"
                size="sm"
                @click="removeAsSignatory(data.item)"
              />
            </template>
          </b-table>
        </div>

        <b-modal
          id="search-modal"
          ref="search-modal"
          centered
          size="lg"
          title="Search Result"
          ok-only
          ok-title="Cancel"
          ok-variant="outline-secondary"
        >
          <b-table
            ref="customerListTable"
            :busy="isBusy"
            :items="customerList"
            responsive
            :fields="tableHeaders"
            primary-key="id"
            show-empty
            selectable
            empty-text="No result found"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            class="position-relative"
            @row-selected="onSelectCustomer"
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner
                  class="align-middle"
                  variant="primary"
                />
              </div>
            </template>
            <template #cell(SN)="data">
              {{ getOverallIndex(data.index) }}
            </template>

            <template #cell(lastName)="data">
              {{
                `${data.item.lastName} ${data.item.firstName} ${data.item.otherNames}`
              }}
            </template>
          </b-table>

          <TablePagination
            v-model="currentPage"
            :from="from"
            :to="to"
            :total-rows="totalEntries"
            :per-page="perPage"
          />

          <template #modal-footer="{}">
            <div />
          </template>
        </b-modal>
      </tab-content>

      <!-- Group Lending Connection tab -->
      <tab-content
        v-if="groupCustomerInfo.customerType === 'GroupJoint'"
        title="Group Lending"
      >
        <Alert
          :show="showFormErrorAlert"
          message="Customer's account name or account number is required"
        />
        <b-row>
          <b-col
            md="12"
            class="mb-2"
          >
            <SwitchButton
              v-model="enableGroupLending"
              label=" Enable Group Lending"
              name="enable-group-lending"
              :readonly="isReadonly"
            />
          </b-col>
        </b-row>
        <b-row v-if="enableGroupLending">
          <b-col md="4">
            <InputField
              id="customer-id"
              v-model="searchParams.customerID"
              label="Customer ID"
              placeholder="Enter customer ID"
              type="number"
            />
          </b-col>
          <b-col md="4">
            <InputField
              id="account-number"
              v-model="searchParams.accountNumber"
              label="Account Number"
              placeholder="Enter account number"
              type="text"
            />
          </b-col>

          <b-col md="4">
            <InputField
              id="account-name"
              v-model="searchParams.accountName"
              label="Account Name"
              placeholder="Enter account name"
              type="text"
            />
          </b-col>
          <b-col md="4">
            <Button
              label="Search"
              size="md"
              class="mt-2"
              @click="handleCustomerAccountSearch"
            />
          </b-col>
        </b-row>

        <div v-if="groupLendingConnectionList !== null">
          <b-table
            ref="groupLendingRef"
            :items="groupLendingConnectionList"
            responsive
            :fields="tableHeadersGroupCustomerAccount"
            primary-key="id"
            show-empty
            selectable
            empty-text="No result found"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            class="position-relative mt-3"
          >
            <template #cell(SN)="data">
              {{ data.index + 1 }}
            </template>

            <template #cell(actions)="data">
              <Button
                label="Remove"
                size="sm"
                @click="removeAsGroupLendingConnection(data.item)"
              />
            </template>
          </b-table>
        </div>

        <b-modal
          id="search-modal-customer-account"
          ref="search-modal-customer-account"
          centered
          size="lg"
          title="Search Result"
          ok-only
          ok-title="Cancel"
          ok-variant="outline-secondary"
        >
          <b-table
            ref="customerListTable"
            :busy="isBusy"
            :items="customerAccountList"
            responsive
            :fields="tableHeadersCustomerAccount"
            primary-key="id"
            show-empty
            selectable
            empty-text="No result found"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            class="position-relative"
            @row-selected="onSelectCustomerAccount"
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner
                  class="align-middle"
                  variant="primary"
                />
              </div>
            </template>
            <template #cell(SN)="data">
              {{ getOverallIndex(data.index) }}
            </template>
          </b-table>

          <TablePagination
            v-model="currentPage"
            :from="from"
            :to="to"
            :total-rows="totalEntries"
            :per-page="perPage"
          />

          <template #modal-footer="{}">
            <div />
          </template>
        </b-modal>
      </tab-content>

      <!-- Other Documents tab-->
      <tab-content
        title="Other Documents"
        :before-change="validatUploads"
      >
        <validation-observer ref="uploadRules">
          <b-form>
            <div>
              <div class="w-full mt-4 p-10">
                <div
                  class="d-flex mb-0 mt-2 align-items-center justify-content-between"
                >
                  <h4>Other Documents Upload</h4>

                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="ml-4"
                    @click="addNewDocument()"
                  >
                    <feather-icon
                      icon="PlusIcon"
                      class="mr-25"
                    />
                    <span>Add New Document</span>
                  </b-button>
                </div>
                <b-row
                  v-for="(item, index) in documentsFormData"
                  :id="index"
                  :key="index"
                  class="mb-2"
                >
                  <b-col md="6">
                    <SelectField
                      id="document-type"
                      v-model="item.type"
                      :reduce="(option) => option.value"
                      label="Document Type"
                      placeholder="Select"
                      :options="documentTypeOptions"
                      error-name="Document Type"
                      rules="required"
                      item="label"
                    />
                  </b-col>
                  <b-col md="7">
                    <label>Upload Documents</label>

                    <div class="upload-image">
                      <Spinner :show="documentLoadSpinner" />
                      <b-form-group>
                        <b-form-file
                          placeholder="Choose a file or drop it here..."
                          drop-placeholder="Drop file here..."
                          accept="image/jpeg, image/png, image/bmp, image/jpg, application/pdf, .doc, .docx, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                          plain
                          @change="onDocumentsUpload(index, $event)"
                        />
                        <div
                          v-if="!item.url"
                          class="upload-instruction"
                        >
                          <h4>Upload Document File</h4>
                          <p>
                            Drag & drop file or choose from your device to
                            upload
                          </p>
                          <p class="format">
                            Format accepted (jpg, bmp, png, jpeg, docx, pdf)
                          </p>
                        </div>
                        <div v-else>
                          <div
                            v-if="
                              item.fileExtension === 'png' ||
                                item.fileExtension === 'jpeg' ||
                                item.fileExtension === 'jpg' ||
                                item.fileExtension === 'bmp'
                            "
                          >
                            <b-img
                              :src="item.url"
                              block
                              rounded
                              width="250px"
                              height="250px"
                            />
                          </div>
                          <div v-if="item.fileExtension === 'pdf'">
                            <b-img
                              :src="pdfIcon"
                              block
                              rounded
                              width="250px"
                              height="250px"
                            />
                          </div>
                          <div v-else-if="item.fileExtension === 'vnd'">
                            <b-img
                              :src="wordIcon"
                              block
                              rounded
                              width="250px"
                              height="250px"
                            />
                          </div>
                          <div v-else>
                            <b-img src="" />
                          </div>
                          <div
                            v-if="item.url"
                            class="trash"
                          >
                            <feather-icon
                              icon="Trash2Icon"
                              size="20"
                              class="text-primary"
                              @click="deleteDocumentFile(item.id, index)"
                            />
                          </div>
                          <div
                            v-if="item.url"
                            class="view-details"
                          >
                            <feather-icon
                              icon="EyeIcon"
                              size="20"
                              class="text-primary"
                              @click="
                                viewDocumentFile(
                                  item.url,
                                  item.fileName,
                                  item.fileExtension
                                )
                              "
                            />
                          </div>
                          <!-- </div> -->
                        </div>
                      </b-form-group>
                    </div>
                  </b-col>
                  <b-col
                    md="3"
                    class="mt-0"
                  >
                    <b-row>
                      <!-- Remove Button -->
                      <b-col
                        md="12"
                        class="mt-1"
                      >
                        <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="primary"
                          class="ml-0"
                          @click="removeDocument(item.id, index)"
                        >
                          <feather-icon
                            icon="XIcon"
                            class="mr-25"
                          />
                          <span>Remove</span>
                        </b-button>
                      </b-col>
                      <b-col
                        md="12"
                        class="mt-1"
                      >
                        <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="primary"
                          class="ml-0"
                          @click="handleDownload(item.url)"
                        >
                          <feather-icon
                            icon="DownloadIcon"
                            class="mr-25"
                          />
                          <span>Download</span>
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-form>
        </validation-observer>
      </tab-content>
      <template slot="finish">
        <div class="wizard-footer-right">
          <Button
            label="Submit"
            :loading="isLoading"
            :disabled="isDisabled"
            size="lg"
            @click="handleSubmit"
          />
        </div>
      </template>
      <b-modal
        id="info-modal"
        ref="infoModal"
        centered
        size="md"
        ok-only
        ok-title="Okay"
        @ok="hideModal('info-modal')"
      >
        <div class="p-2">
          <p>External Customer Reference</p>
        </div>
      </b-modal>

      <b-modal
        id="info-email-modal"
        ref="infoEmailModal"
        centered
        size="md"
        ok-only
        ok-title="Okay"
        @ok="hideModal('info-email-modal')"
      >
        <div class="p-2">
          <p>For multiple Email Addresses, separate by comma (,)</p>
        </div>
      </b-modal>
      <b-modal
        id="info-phone-modal"
        ref="infoPhoneModal"
        centered
        size="md"
        ok-only
        ok-title="Okay"
        @ok="hideModal('info-phone-modal')"
      >
        <div class="p-2">
          <p>For multiple Phone Numbers, separate by comma (,)</p>
        </div>
      </b-modal>
      <b-modal
        id="view-avatar-modal"
        ref="avatarModal"
        no-close-on-backdrop
        ok-title="Download File"
        cancel-title="Cancel"
        cancel-variant="outline-secondary"
        centered
        size="lg"
        :title="viewDocumentModalTitle"
        @hidden="resetDocumentModal"
        @cancel="resetDocumentModal"
        @ok="handleDownload(viewDocumentData)"
      >
        <div class="m-2 text-center">
          <b-row>
            <b-col cols="12">
              <div
                v-if="
                  fileExtension === 'png' ||
                    fileExtension === 'jpeg' ||
                    fileExtension === 'jpg'
                "
              >
                <b-img
                  :src="viewDocumentData"
                  block
                  fluid
                  rounded
                />
              </div>
              <div v-else-if="fileExtension === 'pdf'">
                <b-img
                  :src="pdfIcon"
                  block
                  width="250px"
                  height="250px"
                  rounded
                />
              </div>
              <div v-else-if="fileExtension === 'vnd'">
                <b-img
                  :src="wordIcon"
                  block
                  width="250px"
                  height="250px"
                  rounded
                />
              </div>
              <div v-else>
                <b-img src="" />
              </div>
            </b-col>
          </b-row>
        </div>
      </b-modal>
      <b-modal
        id="tin-validation-modal"
        ref="tinModal"
        no-close-on-backdrop
        ok-title="Continue"
        cancel-title="Cancel"
        cancel-variant="outline-secondary"
        centered
        size="lg"
        title="TIN Validation"
        @ok="handleContinue"
      >
        <div class="m-2">
          <b-row>
            <b-col md="4">
              <InputField
                id="email"
                v-model="tinInformationDetails.email"
                label="Email"
                placeholder="Email"
                type="text"
                readonly
              />
            </b-col>
            <b-col md="4">
              <InputField
                id="phone-number"
                v-model="tinInformationDetails.phone_number"
                label="Phone Number"
                placeholder="Phone Number"
                type="text"
                readonly
              />
            </b-col>
            <b-col md="4">
              <InputField
                id="tax-payer-name"
                v-model="tinInformationDetails.taxpayer_name"
                label="Tax Payer Name"
                placeholder="Tax Payer Name"
                type="text"
                readonly
              />
            </b-col>
            <b-col md="4">
              <InputField
                id="cac-registration-number"
                v-model="tinInformationDetails.cac_reg_number"
                label="CAC Registration Number"
                placeholder="CAC Registration Number"
                type="text"
                readonly
              />
            </b-col>
            <b-col md="4">
              <InputField
                id="first-tin"
                v-model="tinInformationDetails.firstin"
                label="First TIN"
                placeholder="First TIN"
                type="text"
                readonly
              />
            </b-col>
            <b-col md="12">
              <TextAreaField
                id="address"
                v-model="tinInformationDetails.tax_office"
                label="Address"
                placeholder="Enter address"
                error-name="Address"
                rules="required"
                for="address"
                rows="5"
              />
            </b-col>
          </b-row>
        </div>
      </b-modal>
      <FullScreenSpinner :show="showSpinner" />
    </form-wizard>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BForm,
  BTable,
  BSpinner,
  BButton,
  BFormFile,
  BImg,
} from 'bootstrap-vue'
import { FormWizard, TabContent } from 'vue-form-wizard'
import { ValidationObserver } from 'vee-validate'
import { datePickerConfig } from '@core/mixins/datePicker'
import { required, minPhoneVal, maxPhoneVal } from '@validations'
import { permissionMixin } from '@core/mixins/permission'
import { modalMixins } from '@core/mixins/modal'
import { tableMixins } from '@core/mixins/table'
import { mapActions } from 'vuex'
import Ripple from 'vue-ripple-directive'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { v4 as uuidv4 } from 'uuid'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import Spinner from '@/views/components/spinner/Spinner.vue'
import TablePagination from '@/views/components/table/TablePagination.vue'
import InputField from '../../../../forms/InputField.vue'
import SwitchButton from '../../../../components/switch/Switch.vue'
import TextAreaField from '../../../../forms/TextAreaField.vue'
import SelectField from '../../../../forms/SelectField.vue'
import DatePickerField from '../../../../forms/DatePickerField.vue'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import Alert from '../../../../components/alert/Alert.vue'
import Button from '../../../../components/button/Button.vue'
import getStatusColor from '../../../../../helpers/getStatusColor'
import { toYearWithDate, toDateWithYear } from '../../../../../helpers/formatDate'
import {
  industrialSectorsAndCod,
  customerTypes,
  countries,
  pdfIcon,
  wordIcon,
} from '../../../../../helpers/data'
import { accountPermissions } from '../../../../../helpers/permissions'

export default {
  components: {
    BRow,
    BCol,
    BTable,
    SelectField,
    DatePickerField,
    BSpinner,
    FormWizard,
    TabContent,
    BFormGroup,
    BForm,
    BButton,
    BFormFile,
    BImg,
    ValidationObserver,
    InputField,
    TextAreaField,
    SwitchButton,
    FullScreenSpinner,
    Spinner,
    TablePagination,
    Alert,
    Button,
  },
  directives: {
    Ripple,
  },
  mixins: [modalMixins, tableMixins, datePickerConfig, sweetAlert, permissionMixin],
  data() {
    return {
      isDisabled: false,
      isLoading: false,
      showBackButton: false,
      minPhoneVal,
      maxPhoneVal,
      actionType: 'save',
      required,
      sortDesc: false,
      isBusy: false,
      sortBy: 'lastName',
      getStatusColor,
      showFormErrorAlert: false,
      enableGroupLending: false,
      tableHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'customerID', sortable: true },
        { key: 'lastName', sortable: true, label: 'Name' },
        { key: 'phoneNumber', sortable: true },
        { key: 'email', sortable: true },
        { key: 'actions' },
      ],
      tableHeadersCustomerAccount: [
        { key: 'SN', label: 'S/N' },
        { key: 'customerID', sortable: true },
        { key: 'accountName', sortable: true },
        { key: 'accountNumber', sortable: true },
      ],
      tableHeadersGroupCustomerAccount: [
        { key: 'SN', label: 'S/N' },
        { key: 'customerID', sortable: true },
        { key: 'accountName', sortable: true },
        { key: 'accountNumber', sortable: true },
        { key: 'productName', sortable: true },
        { key: 'actions' },
      ],
      countryCode: '',
      lgaOptions: [],
      countryOptions: ['Nigeria'],
      industrialSectorsOptions: industrialSectorsAndCod,
      customerTypeOptions: customerTypes,
      groupCustomerInfo: {
        customerType: '',
        name: '',
        alias: '',
        description: '',
        address: '',
        businessPhoneNumber: '',
        notificationPhoneNumber: '',
        natureOfBusiness: '',
        industrialSector: '',
        registrationDate: '',
        incorporationDate: '',
        registrationNumber: '',
        email: '',
        notificationEmail: '',
        contactPersonName: '',
        contactPersonPhoneNumber: '',
        countryOfOperation: 'Nigeria',
        stateOfOperation: '',
        lga: '',
        tin: '',
        oldCustomerID: '',
      },
      datePickerConfig: {
        dateFormat: 'd/m/Y',
        ariaDateFormat: 'd/m/Y',
      },
      // datePickerConfig: {
      //   dateFormat: 'Y-m-d',
      //   maxDate: '',
      //   defaultDate: '',
      //   ariaDateFormat: 'Y-m-d',
      // },
      customerID: '',
      searchParams: {
        customerID: null,
        name: null,
      },
      customerList: [],
      customerAccountList: [],
      signatoryList: [],
      groupLendingConnectionList: [],
      documentsFormData: [
        {
          type: '',
          url: '',
          file: '',
        },
      ],
      viewDocumentData: '',
      viewDocumentModalTitle: '',
      fileExtension: '',
      documentLoadSpinner: false,
      documentTypeOptions: [
        { value: 1, label: 'Signature Specimen' },
        { value: 2, label: 'Proof Of Address' },
        { value: 3, label: 'Driver’s License' },
        { value: 4, label: 'National Identity Card' },
        { value: 5, label: 'Voters Card' },
        { value: 6, label: 'National Identity Number' },
        { value: 7, label: 'International Passport' },
        { value: 8, label: 'Passport Photograph' },
        { value: 9, label: 'Reference Letter' },
        { value: 10, label: 'Guarantor’s Letter' },
        { value: 11, label: 'Loan Application Form' },
        { value: 12, label: 'Credit Bureau Form' },
        { value: 13, label: 'Others' },
      ],
      documentIdentifier: '',
      pdfIcon,
      wordIcon,
      tinInformationDetails: {},
      isTIN: false,
    }
  },
  computed: {
    stateOptions() {
      const country = countries.find(item => item.name === 'Nigeria')
      return country.states.map(item => item.state).sort()
    },
  },
  watch: {
    currentPage(newValue) {
      this.currentPage = newValue
      this.handleSearch()
    },
    perPage(newValue) {
      this.perPage = newValue
      this.handleSearch()
    },
  },
  mounted() {
    // this.getCountries()
    this.fetchGroupCustomerDetails(0)
  },
  methods: {
    ...mapActions({
      searchCustomerInformation: 'account/getCustomerList',
      searchCustomerAccount: 'account/searchCustomerAccountAction',
      createGroupCustomer: 'account/createGroupCustomerAction',
      updateGroupCustomer: 'account/updateGroupCustomerAction',
      getGroupCustomer: 'account/getCustomer',
      getGroupMembers: 'account/getGroupMembersByGroupId',
      getGroupLendingMembers: 'account/getGroupLendingMembersByGroupId',
      uploadDocumentImages: 'account/uploadDocumentImagesAction',
      deleteDocumentsUpload: 'account/deleteDocumentsUploadAction',
      validateTIN: 'eChannels/validateTINAction',
    }),
    tinValidateAction() {
      if (this.groupCustomerInfo.tin) {
        this.confirm(this.validateTINAction, { text: 'TIN validation comes at a cost to the bank!  Are you sure you want to proceed?' })
      } else {
        this.alertError({ text: 'TIN field is empty' })
      }
    },

    async validateTINAction() {
      try {
        this.isLoading = true
        this.showSpinner = true
        const formData = {
          tin: this.groupCustomerInfo.tin,
          channel: 'TIN',
          requestChannel: 'CBA',
        }
        const response = await this.validateTIN({ formData, permission: accountPermissions.VALIDATE_TIN })
        const { data, status } = response
        if (status === 200 && data.result) {
          this.tinInformationDetails = {
            ...data.result,
          }
          this.showSpinner = false
          this.isLoading = false
          this.$root.$emit('bv::show::modal', 'tin-validation-modal')
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.showSpinner = false
        this.isLoading = false
      }
    },

    handleContinue() {
      this.isTIN = true
      this.groupCustomerInfo = {
        ...this.groupCustomerInfo,
        tin: this.tinInformationDetails.firstin,
        email: this.tinInformationDetails.email,
        notificationEmail: this.tinInformationDetails.email,
        businessPhoneNumber: this.tinInformationDetails.phone_number,
        notificationPhoneNumber: this.tinInformationDetails.phone_number,
        name: this.tinInformationDetails.taxpayer_name,
        registrationNumber: this.tinInformationDetails.cac_reg_number,
        address: this.tinInformationDetails.tax_office,
      }
    },
    addNewDocument() {
      this.documentsFormData.push({
        type: '',
        url: '',
        file: '',
      })
    },
    viewDocumentFile(image, title, fileExtension) {
      this.fileExtension = fileExtension
      this.viewDocumentData = image
      this.viewDocumentModalTitle = title.replace(
        /([a-zA-Z])(?=[A-Z])/g,
        '$1 ',
      )
      this.$root.$emit('bv::show::modal', 'view-avatar-modal')
    },
    resetDocumentModal() {
      this.viewDocumentData = ''
      this.viewDocumentModalTitle = ''
    },
    handleDownload(data) {
      const link = document.createElement('a')
      link.href = data
      link.click()
      this.alertSuccess({
        text: 'Your request to download file was successful',
      })
    },
    async removeDocument(id, index) {
      try {
        this.documentLoadSpinner = true
        const formData = new FormData()
        formData.append('id', id)
        const response = await this.deleteDocumentsUpload({
          formData,
          permission: accountPermissions.VIEW_INDIVIDUAL_CUSTOMER,
        })
        const { status } = response
        if (status === 200) {
          this.documentLoadSpinner = false
          this.documentsFormData.splice(index, 1)
          this.alertSuccess({ text: 'Document Removed' })
        }
      } catch (error) {
        error.response.data.errors.forEach(responseError => {
          this.alertError({
            text: `Delete failed, Reason: ${responseError.errorMessage}`,
          })
        })
      } finally {
        this.documentLoadSpinner = false
      }
    },
    async deleteDocumentFile(id, index) {
      try {
        this.documentLoadSpinner = true
        const formData = new FormData()
        formData.append('id', id)
        const response = await this.deleteDocumentsUpload({
          formData,
          permission: accountPermissions.VIEW_INDIVIDUAL_CUSTOMER,
        })
        const { status } = response
        if (status === 200) {
          this.documentsFormData[index].url = ''
          this.documentLoadSpinner = false
          this.alertSuccess({ text: 'Document Deleted' })
        }
      } catch (error) {
        error.response.data.errors.forEach(responseError => {
          this.alertError({
            text: `Delete failed, Reason: ${responseError.errorMessage}`,
          })
        })
      } finally {
        this.documentLoadSpinner = false
      }
    },

    async onDocumentsUpload(index, event) {
      try {
        this.documentLoadSpinner = true
        const { files } = event.target

        const formData = new FormData()
        formData.append('attachedFile', files[0])
        formData.append('type', this.documentsFormData[index].type)
        formData.append('referenceNumber', this.documentIdentifier)
        const response = await this.uploadDocumentImages({
          formData,
          permission: accountPermissions.VIEW_INDIVIDUAL_CUSTOMER,
        })
        const { status, data } = await response
        if (status === 200 && data) {
          this.documentsFormData[index].url = data.url
          this.documentsFormData[index].id = data.id
          this.documentsFormData[index].fileExtension = data.fileExtension
          this.documentLoadSpinner = false
        }
      } catch (error) {
        error.response.data.errors.forEach(responseError => {
          this.alertError({
            text: `Your request to upload image failed. Reason: ${responseError.errorMessage}`,
          })
        })
      } finally {
        this.documentLoadSpinner = false
      }
    },
    setBussinessPhoneNumber(val) {
      this.groupCustomerInfo.businessPhoneNumber = val
      this.groupCustomerInfo.notificationPhoneNumber = this.groupCustomerInfo.businessPhoneNumber
    },
    setBussinessEmailAddress(val) {
      this.groupCustomerInfo.email = val
      this.groupCustomerInfo.notificationEmail = this.groupCustomerInfo.email
    },
    validateGroup() {
      return new Promise((resolve, reject) => {
        this.$refs.groupRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validatUploads() {
      return new Promise((resolve, reject) => {
        this.$refs.uploadRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    getLGAByState(selectedValue) {
      const country = countries.find(item => item.name === 'Nigeria')
      const selectedState = country.states.find(
        item => item.state === selectedValue,
      )
      this.lgaOptions = selectedState.lgas.sort()
    },
    async groupInformationAction() {
      const action = `${this.actionType === 'save' ? 'Save' : 'Modify'}`
      try {
        this.isLoading = true
        this.isDisabled = true

        let groupMembers = []
        let groupLendingConnections = []

        if (this.signatoryList.length) {
          groupMembers = this.signatoryList.map(items => ({
            customerID: items.customerID,
            isSignatory: items.isSignatory,
          }))
        }
        if (this.groupLendingConnectionList.length) {
          groupLendingConnections = this.groupLendingConnectionList.map(items => ({
            accountNumber: items.accountNumber,
          }))
        }
        const formData = {
          ...this.groupCustomerInfo,
          documentIdentifier: this.documentIdentifier,
          registrationDate: this.groupCustomerInfo.registrationDate
            ? toYearWithDate(this.groupCustomerInfo.registrationDate)
            : null,
          incorporationDate: this.groupCustomerInfo.incorporationDate
            ? toYearWithDate(this.groupCustomerInfo.incorporationDate)
            : null,
          groupMembers,
          groupLendingConnections,
        }

        const response = this.actionType === 'save'
          ? await this.createGroupCustomer(formData)
          : await this.updateGroupCustomer(formData)

        const { status, data } = response
        if (status === 200) {
          const customerID = data?.customerID
            ? data.customerID
            : this.groupCustomerInfo.customerID
          this.alertSuccess({
            text: `Your request to ${action} ${this.groupCustomerInfo.name}'s profile with ${customerID} was successful`,
          })
          this.$router.push({ name: 'group-customer-information' })
        }
      } catch (error) {
        this.alertError({
          text: `Your request to ${action} Customer Information failed. Reason: ${this.readError(
            error,
          )}`,
        })
      } finally {
        this.isLoading = false
        this.isDisabled = false
      }
    },
    onViewInfo() {
      this.$root.$emit('bv::show::modal', 'info-modal')
    },
    onViewEmailInfo() {
      this.$root.$emit('bv::show::modal', 'info-email-modal')
    },
    onViewPhoneInfo() {
      this.$root.$emit('bv::show::modal', 'info-phone-modal')
    },
    async handleSubmit() {
      const action = `${this.actionType === 'save' ? 'Save' : 'Modify'}`
      this.confirm(this.groupInformationAction, {
        title: '',
        text: `Are you sure you want to ${action} this Customer Information?`,
      })
    },
    async handleSearch() {
      try {
        const isSearchParamsNotEmpty = Object.values(this.searchParams).every(
          params => params === null || params === '',
        )
        if (!isSearchParamsNotEmpty) {
          this.showFormErrorAlert = false
          this.showSpinner = true
          this.isBusy = true
          const response = await this.searchCustomerInformation({
            search: this.searchParams,
            page: this.currentPage,
            limit: this.perPage,
            permission:
              this.actionType === 'add'
                ? accountPermissions.CREATE_GROUP_CUSTOMER
                : accountPermissions.MODIFY_GROUP_CUSTOMER,
          })
          const { data, status } = await response
          if (status === 200) {
            this.customerList = data.data
            this.totalCount = data.recordCount
            this.showSpinner = false
            this.$root.$emit('bv::show::modal', 'search-modal')
          }
        } else {
          this.showFormErrorAlert = true
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
        this.isBusy = false
      }
    },
    async handleCustomerAccountSearch() {
      try {
        const isSearchParamsNotEmpty = Object.values(this.searchParams).every(
          params => params === null || params === '',
        )
        if (!isSearchParamsNotEmpty) {
          this.showFormErrorAlert = false
          this.showSpinner = true
          this.isBusy = true
          const response = await this.searchCustomerAccount({
            search: this.searchParams,
            page: this.currentPage,
            limit: this.perPage,
            permission:
              this.actionType === 'add'
                ? accountPermissions.CREATE_GROUP_CUSTOMER
                : accountPermissions.MODIFY_GROUP_CUSTOMER,
          })
          const { data, status } = await response
          if (status === 200) {
            this.customerAccountList = data.data
            this.totalCount = data.recordCount
            this.showSpinner = false
            this.$root.$emit('bv::show::modal', 'search-modal-customer-account')
          }
        } else {
          this.showFormErrorAlert = true
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
        this.isBusy = false
      }
    },
    async fetchGroupCustomerDetails() {
      try {
        this.documentIdentifier = uuidv4()
        const { id } = this.$route.params
        if (id !== undefined) {
          this.showSpinner = true
          this.showBackButton = true
          this.actionType = 'edit'
          const response = await this.getGroupCustomer({
            id,
            permission:
              this.actionType === 'add'
                ? accountPermissions.CREATE_GROUP_CUSTOMER
                : accountPermissions.MODIFY_GROUP_CUSTOMER,
          })
          this.$refs.groupCustomerForm.activateAll()
          const { data, status } = response
          if (status === 200 && data.data) {
            const groupMembers = await this.getGroupMembers({
              permission:
                this.actionType === 'add'
                  ? accountPermissions.CREATE_GROUP_CUSTOMER
                  : accountPermissions.MODIFY_GROUP_CUSTOMER,
              formData: {
                groupCustomerID: data.data.customerID,
                pageNumber: 0,
                pageSize: 0,
              },
            })
            const groupLendingMembers = await this.getGroupLendingMembers({
              permission:
                this.actionType === 'add'
                  ? accountPermissions.CREATE_GROUP_CUSTOMER
                  : accountPermissions.MODIFY_GROUP_CUSTOMER,
              formData: {
                groupCustomerID: data.data.customerID,
                pageNumber: 0,
                pageSize: 0,
              },
            })
            this.customerID = data.data.customerID
            this.groupCustomerInfo = {
              id: data.data.id,
              customerType: data.data.customerType,
              customerID: data.data.customerID,
              name: data.data.name,
              alias: data.data.alias,
              description: data.data.description,
              address: data.data.address,
              businessPhoneNumber: data.data.businessPhoneNumber,
              notificationPhoneNumber: data.data.notificationPhoneNumber,
              natureOfBusiness: data.data.natureOfBusiness,
              industrialSector: data.data.industrialSector,
              registrationDate: data.data.registrationDate ? toDateWithYear(data.data.registrationDate) : null,
              incorporationDate: data.data.incorporationDate ? toDateWithYear(data.data.incorporationDate) : null,
              registrationNumber: data.data.registrationNumber,
              email: data.data.email,
              notificationEmail: data.data.notificationEmail,
              contactPersonName: data.data.contactPersonName,
              contactPersonPhoneNumber: data.data.contactPersonPhoneNumber,
              countryOfOperation: data.data.countryOfOperation,
              stateOfOperation: data.data.stateOfOperation,
              lga: data.data.lga,
              tin: data.data.tin,
              oldCustomerID: data.data.oldCustomerID,
            }
            this.documentIdentifier = data.data.documentIdentifier
              ? data.data.documentIdentifier
              : this.documentIdentifier
            this.documentsFormData = data.data.documents
              ? data.data.documents.map(item => ({
                url: item.url,
                type: item.typeID,
                fileName: item.type,
                id: item.id,
                fileExtension: item.fileExtension,
              }))
              : [
                {
                  url: '',
                  type: '',
                },
              ]
            this.signatoryList = groupMembers.data.data || []
            this.groupLendingConnectionList = groupLendingMembers.data.data || []
          }
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },
    onSelectCustomer(items) {
      try {
        this.showBackButton = true
        const [data] = items
        const customerInfo = { ...data, isSignatory: true }
        if (this.signatoryList !== null) {
          const customerId = this.signatoryList.find(
            item => item.customerID === data.customerID,
          )
          if (customerId) {
            this.alertError({
              text: 'User has already been added to signatory list',
            })
          } else {
            this.signatoryList.push(customerInfo)
          }
        } else {
          this.signatoryList.push(customerInfo)
        }
        this.$bvModal.hide('search-modal')
      } catch (error) {
        this.alertError({ text: error })
      }
    },
    removeAsSignatory(items) {
      const index = this.signatoryList.indexOf(items)
      this.signatoryList.splice(index, 1)
    },
    onSelectCustomerAccount(items) {
      try {
        this.showBackButton = true
        const [data] = items
        const customerInfo = { ...data, isSignatory: true }
        if (this.groupLendingConnectionList !== null) {
          const customerId = this.groupLendingConnectionList.find(
            item => item.customerID === data.customerID,
          )
          if (customerId) {
            this.alertError({
              text: 'User has already been added to signatory list',
            })
          } else {
            this.groupLendingConnectionList.push(customerInfo)
          }
        } else {
          this.groupLendingConnectionList.push(customerInfo)
        }
        this.$bvModal.hide('search-modal-customer-account')
      } catch (error) {
        this.alertError({ text: error })
      }
    },
    removeAsGroupLendingConnection(items) {
      const index = this.groupLendingConnectionList.indexOf(items)
      this.groupLendingConnectionList.splice(index, 1)
    },
    backNavigationAction() {
      this.showBackButton = true
      this.$router.push({
        name: 'group-customer-information',
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }
  ::v-deep .vs__selected {
    width: 100px;
  }
}
.upload-image {
  border: 2px dashed #dcd9d9;
  position: relative;
  width: 250px;
  height: 250px;
}
.format {
  color: #999999 !important;
}
form input[type='file'] {
  position: absolute;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  outline: none;
  opacity: 0;
}
.upload-instruction {
  padding-top: 22%;
  color: #000;
  text-align: center;
}
.trash {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  background: #fff;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  margin-right: 10px;
  cursor: pointer;
}
.view-details {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  background: #fff;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  margin-left: 10px;
  cursor: pointer;
}
// .text-primary {
//     color: #7367f0 !important;
// }
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/base/bootstrap-extended/_include.scss';
</style>
